import React, { useEffect, useState } from 'react';
import { useNavigate } from "react-router-dom";

function Users({ color, classes = '', url }) {
  const navigate = useNavigate();
  const onMenuClick = () => {
    navigate(`/${url}`);
  }
  return (
    <div className={classes} onClick={onMenuClick}>
      <svg fill={color} version="1.1" id="Layer_1" 
      xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 210 256" enableBackground="new 0 0 210 256">
        <path d="M174.55,144.5L174.55,144.5c-1.4-4-5-6.5-9.2-6.5H159V23c0-11.708-9.292-21-21-21H25C12.57,2,2,12.57,2,25v183
	c0,11.9,10.95,22,22.75,22l114.213,0c1.207,0,2.27,0.984,2.18,2.188c-0.095,1.266-1.153,1.812-2.393,1.812h-45.5L128,254h80
	L174.55,144.5z M82.05,220.2c-3.199,0-5.599-2.399-5.6-5.598c-0.001-3.045,2.557-5.602,5.602-5.602
	c3.199,0.001,5.598,2.401,5.598,5.6C87.55,217.8,85.25,220.2,82.05,220.2z M144,138h-19.65c-5.3,0-9.8,4.7-9.8,10l0,0
	c0,5.3,4.5,10,9.8,10h19.8v42H18V31h126V138z M80.012,40.542c9.797,0,17.739,7.942,17.739,17.739S89.809,76.02,80.012,76.02
	s-17.739-7.942-17.739-17.739S70.215,40.542,80.012,40.542z M51.206,129.542v-22.518c0-1.365,0.834-2.198,2.198-2.198
	s2.198,0.834,2.198,2.198v22.518h48.819v-22.518c0-1.365,0.834-2.198,2.198-2.198s2.198,0.834,2.198,2.198v22.518h15.54v-26.99
	c0-12.205-10.006-22.135-22.135-22.135H57.877c-12.205,0-22.135,10.006-22.135,22.135v26.99H51.206z"/>
      </svg>
    </div>
  );
}

export default Users;
